<form [ngSwitch]="quiz.quizType" class="container" [formGroup]="dayForm">
  <ng-container *ngSwitchCase="QUIZTYPE.MULTIPLECHOICE">
    <div class="field-container">
      <label for="options">Select an option</label>
      <mat-radio-group class="column" formControlName="option">
        <ng-container *ngFor="let answer of quiz.options; let index = index">
          <mat-radio-button
            name="option"
            [value]="answer.answer"
            (change)="onChangeOption(answer?.answer)"
          >
            <div class="row">
              <div class="multi-answer">
                {{ ordinal(answer.position) }}.&nbsp;{{ answer.answer }}
              </div>
              <ng-container *ngIf="answer.fileLocation">
                <div class="image-preview">
                  <img [src]="answer.fileLocation" alt="Image Preview" />
                </div>
              </ng-container>
            </div>
          </mat-radio-button>
        </ng-container>
      </mat-radio-group>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="QUIZTYPE.BOOLEANCHOICE">
    <div class="field-container">
      <label for="trueOrFalse">Select an option</label>
      <mat-radio-group formControlName="trueOrFalse">
        <mat-radio-button
          value="true"
          name="trueOrFalse"
          (change)="onChangeTrueFalse('true')"
          >True</mat-radio-button
        >
        <mat-radio-button
          value="false"
          name="trueOrFalse"
          (change)="onChangeTrueFalse('false')"
          >False</mat-radio-button
        >
      </mat-radio-group>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="QUIZTYPE.FREEANSWER">
    <div class="field-container">
      <label for="freeAnswer">Enter your answer here:</label>
      <div class="answer-free">
        <div class="answer-free--item">
          <textarea
            name="freeAnswer"
            formControlName="freeAnswer"
            (ngModelChange)="onChangeFreeAnswer($event)"
          ></textarea>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngSwitchDefault>
    <p>The Assessment cannot be displayed</p>
  </ng-container>
</form>
